import { makeStyles } from '@material-ui/core/styles';

export default makeStyles((theme) => ({
  card: {
    display: 'flex',
    flexDirection: ({ me }) => (me ? 'row-reverse' : 'row'),
    alignItems: ({ me }) => (me ? 'flex-end' : 'flex-start'),
    margin: '4px 0',
  },
  chat: {
    display: 'flex',
    flexDirection: 'column',
    padding: '8px 12px 4px',
    justifyContent: 'space-between',
    color: '#424346',
    maxWidth: '80%',
    minWidth: '80px',
    fontSize: '12px',
    overflowWrap: 'break-word',
    // boxShadow:
    //   '0px 0px 0.571px 0px rgba(66, 71, 76, 0.32), 0px 4.571px 6.857px 0px rgba(66, 71, 76, 0.08)',
    background: ({ me }) => (me ? '#E0FAEC' : '##FFFFFF'),
    border: ({ me }) => (me ? '1px solid #C2F5DA' : '1px solid #CACFD8'),
    borderRadius: ({ me }) => (me ? '8px 0 8px 8px' : '0 8px 8px 8px'),
    // border: ({ me }) => (me ? '1.5px solid #FFECC0' : '1px solid #FFECC0'),
  },
  chatInstructions: {
    display: 'flex',
    flexDirection: 'column',
    padding: '8px 12px',
    justifyContent: 'space-between',
    color: '#424346',
    width: '100%',
    marginTop: 10,
    fontSize: '12px',
    boxShadow:
      '0px 0px 0.571px 0px rgba(66, 71, 76, 0.32), 0px 4.571px 6.857px 0px rgba(66, 71, 76, 0.08)',
    background: '#F5F9FF',
    borderRadius: 8,
    border: '1.5px solid #9DC0EE',
  },
  chatInfo: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    borderBottom: '1px solid #E8E8E8',
    paddingBottom: 8,
    marginBottom: 10,
  },
  chatUserInfo: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    gap: 5,
  },
  chatInstructionsInfo: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    gap: 5,
    fontFamily: 'Averta Bold',
    alignItems: 'center',
    fontSize: 14,
    '& div': {
      padding: 0,
      height: 24,
    },
  },
  title: {
    fontSize: 12,
    fontFamily: 'Averta Light',
    fontWeight: 300,
    lineHeight: 1.6,
    color: '#424346',
    // marginBottom: 12,
    // wordBreak: 'break-all',
  },

  time: {
    display: 'flex',
    justifyContent: 'flex-end',
    fontSize: 8,
    fontFamily: 'Averta Light',
    fontWeight: 300,
    lineHeight: 1.3,
    color: '#979797',
    width: '100%',
  },

  avatar: {
    height: 22,
    width: 22,
    // margin: ({ me }) => (me ? '0 0 0 5px' : '0 5px 0 0'),
  },
  img: {
    height: 200,
    borderRadius: 20,
    marginBottom: 10,
    objectFit: 'contain',
  },
  // chatLine: {
  //   display: 'block',
  // },
}));
